export const amlAccountsColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'deletedAt',
    label: '',
    hidden: true,
  },
  {
    name: 'transferDate',
    label: 'Date',
  },
  {
    name: 'typeId',
    label: 'Type',
  },
  {
    name: 'currencyId',
    label: 'Currency',
  },
  {
    name: 'baseellaStatus',
    label: 'Status',
  },
  {
    name: 'paymentType',
    label: 'Payment Type',
  },
  {
    name: 'sum',
    label: 'Amount',
  },
];

export const amlAccountsColumnsLabels = {};

export const amlAccountsDefaultSorter = {};

export const amlAccountsSchema = {};

export const amlAccountsFiltersSchema = [];
